import { useCallback, useState } from 'react';
import { coverUploadRefusal, type CoverUploadError } from '../panels/picture/useReferenceUpload';
import { savePublicUpload } from './publicUploadStore';

/**
 * The own picture of a visitor of the public tool (spec §2): it never goes to the server. The
 * picture gets a local address for the canvas, and its bytes are kept in this browser, so a reload
 * still has it. The same rules as the upload of an account: JPEG, PNG or WebP, at most 25 MB.
 */
export function useLocalPictureUpload() {
  const [error, setError] = useState<CoverUploadError | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const uploadPicture = useCallback(async (file: File): Promise<{ fileId: null; url: string } | null> => {
    const refusal = coverUploadRefusal(file);
    if (refusal !== null) {
      setError(refusal);
      return null;
    }
    setError(null);
    setIsUploading(true);
    try {
      await savePublicUpload(file);
      return { fileId: null, url: URL.createObjectURL(file) };
    } finally {
      setIsUploading(false);
    }
  }, []);

  return { uploadPicture, isUploading, error };
}
